export class QualityData {
  constructor({
        id= null, 
        planCode= ``,
        itemName=``, 
        sampleName=``,
        sampleCode= ``, 
        sentPerson= ``,
        checkPerson='',
        sentTime= ``,
        receiveTime= ``,
        status='',
        shift='',
        furnaceName='',
        furnaceBatch='',
        // planDate='',
        planDateStr ='',
        plant='',
    } = {}) {
    this.id = id;
    this.planCode = planCode;
    this.itemName =itemName;
    this.sampleName = sampleName;
    this.sampleCode = sampleCode;
    this.status=status;
    this.shift=shift;
    this.sentTime=sentTime;
    this.receiveTime=receiveTime;
    this.sentPerson=sentPerson;
    this.checkPerson=checkPerson;
    this.furnaceName=furnaceName;
    this.furnaceBatch=furnaceBatch;
    // this.planDate=planDate;
    this.planDateStr = planDateStr;
    this.plant=plant;
  }
}
export function gridFields() {
  return Object.freeze(
      [
      
      
      {
        key: 'planCode',
        label: 'lbl.qualityData.planCode',
        sortable: true,
        form: {
          type: 'input'
        }
      },  
      {
        key: 'sampleCode',
        label: 'lbl.qualityData.sampleCode',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'sampleName',
        label: 'lbl.qualityData.sampleName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'planDateStr',
        label: 'lbl.qualityData.planDate',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'plant',
        label: 'lbl.qualityData.plant',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'shift',
        label: 'lbl.qualityData.shift',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'sentPerson',
        label: 'lbl.qualityData.sentPerson',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'sentTime',
        label: 'lbl.qualityData.sentTime',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'checkPerson',
        label: 'lbl.qualityData.person',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'furnaceName',
        label: 'lbl.qualityData.furnaceName',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'furnaceBatch',
        label: 'lbl.qualityData.furnaceBatch',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'receiveTime',
        label: 'lbl.qualityData.checkTime',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'itemName',
        label: 'lbl.qualityData.itemName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'status',
        label: 'lbl.qualityData.status',
        sortable: true,
        form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'N', text:  'lbl.qualityData.status.N' },  
                { value: 'R', text:  'lbl.qualityData.status.R' }, 
                { value: 'C', text:  'lbl.qualityData.status.C' }, 
                                 
              ]     
        }
      }          
     
  ]);
}
export const fields = Object.freeze(Object.keys(new QualityData()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.planCodeFilter',
  'filter.planDateStrFilter',
  'filter.plantFilter',
  'filter.sentTimeFilter',
  'filter.shiftFilter',
  'filter.furnaceNameFilter',
  'filter.furnaceBatchFilter',
  'filter.itemNameFilter',
  'filter.statusFilter'
];
export const filter = {
  'planCodeFilter': "",
  'planDateStrFilter': "",
  'plantFilter':"",
  'sentTimeFilter': "",
  'shiftFilter': "",
  'furnaceNameFilter':"",
  'furnaceBatchFilter':"",
  'itemNameFilter': "",
  'statusFilter': "",
  
};